export default __webpack_public_path__ + "static/media/3632.05d83580.png";